import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { fetchApiWithError } from '@upright/ui/api/common/fetchers/fetch-with-error';
import {
  AddOrEditDataSourceRequest,
  AddOrEditDataSourceResponse,
  DeleteDataSourceRequest,
  DeleteDataSourceResponse,
  GetAccessibleDataSourcesResponse,
  GetAllDataSourcesResponse,
  GetPublicDataSourcesResponse,
} from '../../../../../common/model/input/data-sources/api-types';
import { PartialDataSource } from '../../../../../common/model/input/data-sources/types';

export async function addDataSource(payload: AddOrEditDataSourceRequest) {
  return await fetchOrThrow<AddOrEditDataSourceResponse>(`/data-sources`, 'POST', payload);
}

export async function getAllDataSources() {
  return await fetchOrThrow<GetAllDataSourcesResponse>('/data-sources', 'GET');
}

export async function getAccessibleDataSources() {
  return await fetchOrThrow<GetAccessibleDataSourcesResponse>('/data-sources/accessible', 'GET');
}

export async function getPublicDataSources() {
  return await fetchOrThrow<GetPublicDataSourcesResponse>(`/data-sources/public`, 'GET');
}

export async function deleteDataSource(id: string, payload: DeleteDataSourceRequest) {
  return await fetchApiWithError<DeleteDataSourceResponse>(`/data-source/${id}`, 'DELETE', payload);
}

export async function editDataSource(id: string, payload: PartialDataSource) {
  return await fetchApiWithError<AddOrEditDataSourceResponse>(`/data-source/${id}`, 'PATCH', payload);
}
